<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <g id="surface1">
      <path
        style="
          stroke: none;
          fill-rule: nonzero;
          fill: rgb(58.431373%, 74.901961%, 27.45098%);
          fill-opacity: 1;
        "
        d="M 27.96875 6.285156 C 27.945312 6.125 27.785156 6.035156 27.652344 6.027344 C 27.523438 6.015625 24.730469 5.835938 24.730469 5.835938 C 24.730469 5.835938 22.792969 4.148438 22.578125 3.960938 C 22.367188 3.773438 21.953125 3.832031 21.789062 3.871094 C 21.765625 3.878906 21.367188 3.988281 20.707031 4.167969 C 20.058594 2.53125 18.914062 1.03125 16.90625 1.03125 C 16.851562 1.03125 16.792969 1.035156 16.734375 1.035156 C 16.164062 0.375 15.457031 0.0859375 14.84375 0.0859375 C 10.160156 0.0859375 7.925781 5.21875 7.222656 7.828125 C 5.402344 8.320312 4.109375 8.671875 3.945312 8.71875 C 2.929688 8.996094 2.898438 9.023438 2.765625 9.863281 C 2.664062 10.5 0.0078125 28.519531 0.0078125 28.519531 L 20.714844 31.921875 L 31.933594 29.792969 C 31.933594 29.792969 27.996094 6.445312 27.96875 6.285156 Z M 19.5625 4.476562 L 17.808594 4.953125 C 17.808594 4.84375 17.808594 4.738281 17.808594 4.621094 C 17.808594 3.605469 17.648438 2.789062 17.390625 2.140625 C 18.425781 2.253906 19.117188 3.289062 19.5625 4.476562 Z M 16.105469 2.339844 C 16.394531 2.972656 16.582031 3.882812 16.582031 5.105469 C 16.582031 5.167969 16.582031 5.226562 16.582031 5.285156 C 15.441406 5.59375 14.203125 5.929688 12.960938 6.269531 C 13.660156 3.910156 14.964844 2.769531 16.105469 2.339844 Z M 14.714844 1.1875 C 14.917969 1.1875 15.121094 1.246094 15.316406 1.363281 C 13.816406 1.984375 12.207031 3.542969 11.527344 6.65625 L 8.667969 7.433594 C 9.460938 5.058594 11.351562 1.1875 14.714844 1.1875 Z M 14.714844 1.1875 "
      />
      <path
        style="
          stroke: none;
          fill-rule: nonzero;
          fill: rgb(36.862745%, 55.686275%, 24.313725%);
          fill-opacity: 1;
        "
        d="M 27.652344 6.027344 C 27.523438 6.015625 24.730469 5.835938 24.730469 5.835938 C 24.730469 5.835938 22.792969 4.148438 22.578125 3.960938 C 22.5 3.890625 22.394531 3.855469 22.28125 3.839844 L 20.714844 31.921875 L 31.933594 29.792969 C 31.933594 29.792969 27.996094 6.445312 27.96875 6.285156 C 27.945312 6.125 27.785156 6.035156 27.652344 6.027344 "
      />
      <path
        style="
          stroke: none;
          fill-rule: nonzero;
          fill: rgb(100%, 100%, 100%);
          fill-opacity: 1;
        "
        d="M 16.90625 11.460938 L 15.523438 15.070312 C 15.523438 15.070312 14.308594 14.503906 12.824219 14.503906 C 10.644531 14.503906 10.535156 15.699219 10.535156 16.003906 C 10.535156 17.652344 15.433594 18.28125 15.433594 22.144531 C 15.433594 25.179688 13.238281 27.136719 10.277344 27.136719 C 6.722656 27.136719 4.902344 25.195312 4.902344 25.195312 L 5.855469 22.4375 C 5.855469 22.4375 7.722656 23.84375 9.300781 23.84375 C 10.332031 23.84375 10.75 23.132812 10.75 22.613281 C 10.75 20.464844 6.730469 20.367188 6.730469 16.835938 C 6.730469 13.863281 9.164062 10.984375 14.078125 10.984375 C 15.96875 10.984375 16.90625 11.460938 16.90625 11.460938 "
      />
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ShopifyLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
